module.exports = __webpack_public_path__ + "platform-web/static/media/chevron-right.2826181c.svg";